import FormControlLabel from '@mui/material/FormControlLabel';
import { useState } from 'react';
import { TextField } from '@mui/material';
import { IOSSwitch } from '../common/IosSwitch';
import Collapse from '@mui/material/Collapse';
import { useDispatch, useSelector } from 'react-redux';
import { selectLienHolderInfo } from '../../redux-state/selectors';
import { UPDATE_LIEN_HOLDER_INFO } from '../../redux-state/forms/types';

function LienHolderInformation() {
  const [isFieldVisible, setIsFieldVisible] = useState(true);
  const lienHolderInfo = useSelector(selectLienHolderInfo);
  const dispatch = useDispatch();

  const handleChange = (key, value) => {
    dispatch({
      type: UPDATE_LIEN_HOLDER_INFO,
      payload: { key, value },
    });
  };

  return (
    <div>
      <div className={`flex flex-row justify-between p-4 ${isFieldVisible ? 'rounded-t-xl' : 'rounded-xl'} bg-white text-gray-700`}>
        <div className="text-md font-bold">Lienholder Information</div>
        <div className="flex flex-row">
          <div className="mt-1">{isFieldVisible ? 'Hide Detail' : 'Show Detail'}</div>
          <FormControlLabel
            control={<IOSSwitch sx={{ ml: 3 }} checked={isFieldVisible} onChange={(e) => setIsFieldVisible(e.target.checked)} />}
          />
        </div>
      </div>

      <Collapse in={isFieldVisible} timeout={500} unmountOnExit>
        <div className="flex flex-col bg-white p-4 gap-4 rounded-b-xl text-gray-900">
          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Lienholder Company Name"
              variant="outlined"
              fullWidth
              value={lienHolderInfo.lienholderCompanyName}
              onChange={(e) => handleChange('lienholderCompanyName', e.target.value,)}
            />
            <TextField
              label="Lienholder Address"
              variant="outlined"
              fullWidth
              value={lienHolderInfo.lienholderAddress}
              onChange={(e) => handleChange('lienholderAddress', e.target.value,)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Lienholder Address 2"
              variant="outlined"
              fullWidth
              value={lienHolderInfo.lienholderAddress2}
              onChange={(e) => handleChange('lienholderAddress2', e.target.value,)}
            />
            <TextField
              label="Lienholder City"
              variant="outlined"
              fullWidth
              value={lienHolderInfo.lienholderCity}
              onChange={(e) => handleChange('lienholderCity', e.target.value,)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Lienholder State"
              variant="outlined"
              fullWidth
              value={lienHolderInfo.lienholderState}
              onChange={(e) => handleChange('lienholderState', e.target.value,)}
            />
            <TextField
              label="Lienholder ZIP Code"
              variant="outlined"
              fullWidth
              value={lienHolderInfo.lienholderZip}
              onChange={(e) => handleChange('lienholderZip', e.target.value,)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Lienholder Federal Tax ID"
              variant="outlined"
              fullWidth
              value={lienHolderInfo.lienholderFederalTaxId}
              onChange={(e) => handleChange('lienholderFederalTaxId', e.target.value,)}
            />
            <TextField
              label="Lienholder State Tax ID"
              variant="outlined"
              fullWidth
              value={lienHolderInfo.lienholderStateTaxId}
              onChange={(e) => handleChange('lienholderStateTaxId', e.target.value,)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Lienholder ELT Name"
              variant="outlined"
              fullWidth
              value={lienHolderInfo.lienholderEltName}
              onChange={(e) => handleChange('lienholderEltName', e.target.value,)}
            />
            <TextField
              label="Lienholder ELT ID"
              variant="outlined"
              fullWidth
              value={lienHolderInfo.lienholderEltId}
              onChange={(e) => handleChange('lienholderEltId', e.target.value,)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Lienholder ELT Address"
              variant="outlined"
              fullWidth
              value={lienHolderInfo.lienholderEltAddress}
              onChange={(e) => handleChange('lienholderEltAddress', e.target.value,)}
            />
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default LienHolderInformation;
